import { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { MenuContext } from "../../App";
import SearchedComponent from "../../components/SearchedComponent";
import { fetchAllDispensationService } from "../../services/dispensationManagementService";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import useDebounceSearch from "../../hooks/useDebounceSearch";

const DispensationManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [canAddDispensation, setCanAddDispensation] = useState(false);
  const [canViewDispensationDetails, setCanViewDispensatinDetails] =
    useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const navigate = useNavigate();

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      fetchAllDispensations(page, pageSize, access_token, debounceQuery);
    }
  }, [pageSize, page, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      let canSee = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateDispensation"
      );
      const canSeeList = systemActions?.find(
        (item) => item?.name === "CanViewDispensationDetailList"
      );
      if (createFound) {
        canAdd = true;
      }
      if (canSeeList) {
        canSee = true;
      }
      setCanAddDispensation(canAdd);
      setCanViewDispensatinDetails(canSee);
    } else if (role === "Admin") {
      setCanAddDispensation(true);
      setCanViewDispensatinDetails(true);
    }
  }, [systemActions]);

  useEffect(() => {
    if (canViewDispensationDetails == false) {
      setHiddenColumns(["action"]);
    } else if (canViewDispensationDetails) {
      setHiddenColumns([]);
    }
  }, [canViewDispensationDetails]);

  const columns = [
    {
      field: "visitTreatment",
      headerName: "Visit-Treatment",
      width: 400,
      renderHeader: () => (
        <div className="grid-heading">{"Visit-Treatment"}</div>
      ),
      renderCell: (params) => {
        const name = params?.row?.visitTreatment;
        const id = params.row.id;

        return (
          <>
            <button
              className="bread-crumbs-link grid-nav-btn"
              onClick={() => {
                navigate("/addUpdate-dispensation-management", {
                  state: {
                    id: id,
                  },
                });
              }}
            >
              {name}
            </button>
          </>
        );
      },
    },
    {
      field: "isRequired",
      headerName: "Is Required",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Is Required"}</div>,
      renderCell: (params) => {
        const isRequired = params.row.isRequired;

        return (
          <span className="data-font">{isRequired ? "True" : "False"}</span>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 400,
      renderHeader: () => <div className="grid-heading">{"Action"}</div>,
      renderCell: (params) => {
        const id = params.row.id;

        return (
          <div className="grid-action-cell">
            <button
              className="grid-edit-btn"
              onClick={() => {
                navigate(`/add-dispensation-details`, {
                  state: {
                    id: id,
                    name: `${params.row.visitName} - ${params.row.treatmentName}`,
                  },
                });
              }}
            >
              <EditOutlinedIcon className="grid-edit-icon" />
            </button>
          </div>
        );
      },
    },
  ];

  const fetchAllDispensations = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllDispensationService(
        page + 1,
        pageSize,
        access_Token,
        debouncedSearch
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/dispensation-management">
            Dispensation Management
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Dispensation Management</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Dispensation"
                searchedValue={searchedValue}
              />
              {canAddDispensation ? (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-dispensation-management")}
                >
                  Add New Dispensation
                </button>
              ) : null}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
            hidden={hiddenColumns?.length > 0 ? hiddenColumns : []}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default DispensationManagement;
